import React, { Component, Fragment } from 'react';

import {ModalLoaderPropsInterface} from "#app/interface/modal/types";
import Portal from '#app/interface/portal/Portal';

import { ModalLoader as Loader, Overlay, Wrapper } from './styles';

class ModalLoader extends Component<ModalLoaderPropsInterface> {
  static pageYOffset = 0;

  render() {
    return (
      <Fragment>
        <Portal id="loader">
          <Overlay $show={this.props.show}>
            <Wrapper>
              <Loader />
            </Wrapper>
          </Overlay>
        </Portal>
      </Fragment>
    );
  }
}

export default ModalLoader;
